export const PERFORMANCE_REPORT_PLATFORMS = [
  {
    key: 'meta',
    label: 'Meta',
    reportId: 'a3f6abf9-a07c-4733-a650-4cfa9ae43b63',
    pageId: 'p_qv56n4ywhd',
    filterKey: 'df10',
    quoteStyle: 'encoded',
  },
  {
    key: 'newsbreak',
    label: 'NewsBreak',
    reportId: '5ebb521a-b1a2-40eb-8229-cdc23aeba5a3',
    pageId: 'p_rexkzbc6kd',
    filterKey: 'df13',
    quoteStyle: 'encoded',
  },
  {
    key: 'snapchat',
    label: 'Snapchat',
    reportId: 'bacfab08-622f-4e9f-9df5-b600f562f25a',
    pageId: 'p_rexkzbc6kd',
    filterKey: 'df13',
    quoteStyle: 'literal',
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    reportId: 'bb28e9ae-69b4-4ed9-ab1f-162b2b18f644',
    pageId: 'p_rexkzbc6kd',
    filterKey: 'df13',
    quoteStyle: 'literal',
  },
  {
    key: 'bing',
    label: 'Microsoft Ads',
    reportId: '36b409bc-a466-4d14-ac1c-8e4e23e5b5d8',
    pageId: 'p_rexkzbc6kd',
    filterKey: 'df13',
    quoteStyle: 'literal',
  },
  {
    key: 'google',
    label: 'Google',
    reportId: '08c30927-8f2e-4ec3-b576-134631c1e6bf',
    pageId: 'p_rexkzbc6kd',
    filterKey: 'df13',
    quoteStyle: 'encoded',
  },
  {
    key: 'smartnews',
    label: 'SmartNews',
    reportId: 'e5ffce4d-5c4d-4b58-ab55-0a26fc72dbac',
    pageId: 'p_rexkzbc6kd',
    filterKey: 'df13',
    quoteStyle: 'literal',
  },
]

export const findPerformanceReportPlatform = key => PERFORMANCE_REPORT_PLATFORMS.find(platform => platform.key === key)

const LOOKER_EMBED_BASE = 'https://lookerstudio.google.com/embed/reporting'

export const buildPerformanceReportUrl = (platformKey, companyHash) => {
  const platform = findPerformanceReportPlatform(platformKey)

  if (!platform || !companyHash) {
    return null
  }

  const quote = platform.quoteStyle === 'literal' ? '"' : '%22'

  return (
    `${LOOKER_EMBED_BASE}/${platform.reportId}/page/${platform.pageId}` +
    `?params=%7B${quote}${platform.filterKey}${quote}:${quote}include` +
    `%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580${companyHash}${quote}%7D`
  )
}
